enum AuthorizationAction {
  FETCH_USER = 'auth/getUser',
  LOG_OUT = 'auth/logout'
}

export default AuthorizationAction;
